export default "__VITE_ASSET__vMHDwJ8J__"